import ArrowIcon from '@raison/static/icons/arrow-right-up-line.svg';
import FileIcon from '@raison/static/icons/file-3-line.svg';
import {InlineSvg, RootLayout, RsnPane, RsnSkeleton} from '@raison/ui-kit';
import {useQuery} from '@tanstack/react-query';
import React from 'react';
import {useDocumentsOptions} from '../api/documents';
import {Document} from '../model/document';

export function DocumentsPage() {
    const {data, isPending} = useQuery(useDocumentsOptions());

    return (
        <RootLayout title={'Documents'}>
            {isPending ? <DocumentsSkeleton /> : <DocumentsList data={data ?? []} />}
        </RootLayout>
    );
}

function DocumentsList({data}: {data: Document[]}) {
    if (data.length === 0) {
        return (
            <div
                className={'fv-text-xl-regular flex flex-1 items-center justify-center p-4 text-center text-neutral-60'}
            >
                No documents yet
            </div>
        );
    }

    return (
        <div className={'pb-4 pt-2'}>
            <div className={'px-4 pb-2 pt-4'}>
                <div className={'fv-heading-s text-neutral-100'}>Investment management</div>
                <div className={'fv-text-m-regular text-neutral-60'}>Raison Asset Management Corp.</div>
            </div>
            {data.map(({title, url}, i) => (
                <RsnPane key={i} as={'a'} href={url} target={'_blank'}>
                    <RsnPane.IconFrame>
                        <RsnPane.SVGIcon src={FileIcon} />
                    </RsnPane.IconFrame>
                    <RsnPane.TextBlock>
                        <RsnPane.PrimaryText>{title}</RsnPane.PrimaryText>
                    </RsnPane.TextBlock>
                    <InlineSvg className={'size-5 text-neutral-90'} src={ArrowIcon} />
                </RsnPane>
            ))}
        </div>
    );
}

function DocumentsSkeleton() {
    return (
        <div className={'pb-4 pt-2'}>
            <div className={'px-4 pb-2 pt-4'}>
                <RsnSkeleton width={190} height={20} />
                <RsnSkeleton width={175} height={16} />
            </div>
            <div className={'relative'}>
                {Array.from({length: 6}).map((_, i) => (
                    <RsnPane key={i}>
                        <RsnSkeleton width={36} height={36} circle />
                        <RsnPane.TextBlock>
                            <RsnPane.PrimaryText>
                                <RsnSkeleton width={180} height={20} />
                            </RsnPane.PrimaryText>
                        </RsnPane.TextBlock>
                    </RsnPane>
                ))}
                <div className={'absolute top-0 z-10 h-full w-full bg-gradient-to-b from-transparent to-neutral-10'} />
            </div>
        </div>
    );
}
